import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _WorkActivity } from '../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../theme/Component/Modal';
import { BasicTable } from '../../theme/Component/BasicTable';
import usePaginator from '../../theme/Component/usePaginator';

interface Props {
    label?: string;
    idSelector: number;
    onChange?: any;
    tasksTypes?: "NotAssigned" | "All"
}

export const EditorWorkActivity = ({ idSelector, label, onChange, tasksTypes = "All" }: Props) => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_WorkActivity);
    const paginador = usePaginator();

    const [modal, setModal] = useState<any>({ name: 'Buscar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (idSelector && typeof idSelector === 'number' && bean.IDWorkActivity != idSelector) {
            instance.getWorkActivity(idSelector).then(
                (resp) => {
                    onChange(resp);
                    setBean(resp);
                }
            ).catch(() => toast.error("No se pudo traer la información"));
        }
    }, [idSelector]);

    const getLista = () => {
        instance.getWorkActivityRender(paginador.page, 15, { State: 1 }, tasksTypes == "NotAssigned" ? true : false).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                resp.List.forEach(element => {
                    element.DataBeanProperties.EntityActivity = `${element.DataBeanProperties.WorkActivityCode ?? "N/P"}` + " " + `${element.DataBeanProperties.Name ?? "N/P"}`;
                    element.DataBeanProperties.EmployeEntity = element.DataBeanProperties.IDEmployee ? `${element.DataBeanProperties.AccountNit ?? "S/D"} - ${element.DataBeanProperties.AccountFullName ?? ""}` : "N/A";
                    element.DataBeanProperties.ReporterEntity = element.DataBeanProperties.IDReporter ? `${element.DataBeanProperties.AccountReporterNit ?? "S/D"} - ${element.DataBeanProperties.AccountReporterFullName ?? ""}` : "N/P";
                    element.DataBeanProperties.SolverEntity = element.DataBeanProperties.IDSolver ? `${element.DataBeanProperties.AccountSolverNit ?? "S/D"} - ${element.DataBeanProperties.AccountSolverFullName ?? ""}` : "N/A";
                    element.DataBeanProperties.StatusEntity = element.DataBeanProperties.IDWorkActivityStatuses ? `${element.DataBeanProperties.StatusesName} (${element.DataBeanProperties.StatusesCategory})` : "N/A";
                });
                setLista(resp.List);
            }
        ).catch((err) => toast.error(err));
    }

    const head = [
        { title: 'ID', property: 'IDWorkActivity', visible: true },
        { title: 'Actividad', property: 'EntityActivity', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha de Reporte', property: 'Since', visible: true },
        { title: 'Fecha de inicio', property: 'FromDate', visible: false },
        { title: 'Fecha de finalización', property: 'UptoDate', visible: false },
        { title: 'Vencimiento', property: 'DefeatDate', visible: true },
        { title: 'Usuario Asignado', property: '', visible: true }, //IDEmployee
        { title: 'Reportador', property: '', visible: true }, //IDAccount
        { title: 'Estado', property: '', visible: false }, //WorkActivityStatuses
        { title: 'Prioridad', property: '', visible: false }, //WorkActivityPriority
        { title: 'Tipo de Tarea', property: '', visible: false }, //WorkActivityType
        { title: 'Clasificación', property: '', visible: false }, //WorkActivityTaskType
    ];

    const selectItem = () => {
        let x = bean;
        setModal({ ...modal, "view": false });
        if (onChange) {
            onChange(x);
        }
    };

    useEffect(() => {
        getLista();
    }, []);


    return (
        <>
            {label && label != " " &&
                < label > {label ?? "Tareas de la entidad"}</label>
            }
            <input
                type="text"
                className="form-control"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                placeholder="Buscar..."
                value={bean.IDWorkActivity ? `${bean.EntityActivity}` : ""}
                onClick={() => { setModal({ ...modal, "view": true }) }}
            />

            <Modal modal={modal} updateModal={setModal} eventModal={() => { selectItem() }}>
                <BasicTable body={lista} head={head} rowSet={setBean} />
            </Modal>
        </>
    );
}
